// extracted by mini-css-extract-plugin
export default {"primary":"Button_primary__VIPCG","disabled":"Button_disabled__gCPRN"};